import React from 'react';
import Navbar from './Navbar';
import NavBottom from './NavBottom';
import pic1 from './Images/pic1.png'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


const AboutMe = () => { 
    const htmlValue = 0.85;
    const cssValue = 0.66;
    const sassValue = 0.50;
    const bootstrapValue = 0.70;
    const javascriptValue = 0.65;
    const jqueryValue = 0.60;
    const wowjsValue = 0.75;
    const animejsValue = 0.70;
    const reactValue = 0.75;
    return (
        <>
            <Navbar />
            <div className='me' id='#me'>
                <div className='about-top-title'>
                    <h1 className='about-me-text'>About Me</h1>
                </div>
                <div className='about-text'>
                    <div className="respons-img">
                        <img className='about-img' src={pic1} alt="image here..." />
                    </div>
                    <div>
                        <p className='respons-about-text'>
                            I am researching the field of Frontend Development where I can fulfill my passion for programming technology. I have worked on technologies such as HTML, CSS, Sass, Bootstrap, JavaScript, jQuery and React during my studies in this field. I have worked on various projects, gaining hands-on experience in creating user-friendly and responsive web applications. I want to continue to learn and develop my experience in this interesting field.
                        </p>
                    </div>
                </div>
                <div className="skills-me">
                    <div className="title">
                        <h1 className='about-me-text skills-text'>Skills</h1>
                    </div>
                    <div className="skills-all">
                        <section>
                            <CircularProgressbar value={htmlValue} maxValue={1} text={`${htmlValue * 100}%`} />
                            <span>HTML</span>
                        </section>
                        <section>
                            <CircularProgressbar value={cssValue} maxValue={1} text={`${cssValue * 100}%`} />
                            <span>CSS</span>
                        </section>
                        <section>
                            <CircularProgressbar value={sassValue} maxValue={1} text={`${sassValue * 100}%`} />
                            <span>SASS</span>
                        </section>
                        <section>
                            <CircularProgressbar value={bootstrapValue} maxValue={1} text={`${bootstrapValue * 100}%`} />
                            <span>Bootstrap</span>
                        </section>
                        <section>
                            <CircularProgressbar value={javascriptValue} maxValue={1} text={`${javascriptValue * 100}%`} />
                            <span>JavaScript</span>
                        </section>
                        <section>
                            <CircularProgressbar value={jqueryValue} maxValue={1} text={`${jqueryValue * 100}%`} />
                            <span>jQuery</span>
                        </section>
                        <section>
                            <CircularProgressbar value={wowjsValue} maxValue={1} text={`${wowjsValue * 100}%`} />
                            <span>wow JS</span>
                        </section>
                        <section>
                            <CircularProgressbar value={animejsValue} maxValue={1} text={`${animejsValue * 100}%`} />
                            <span>Anime JS</span>
                        </section>
                        <section>
                            <CircularProgressbar value={reactValue} maxValue={1} text={`${reactValue * 100}%`} />
                            <span>React</span>
                        </section>
                    </div>
                </div>
            </div>
            <NavBottom />
        </>
    );
}


export default AboutMe;